import { doCall } from "common/genericSaga";
import { getGlobalObject } from "helpers/globalObject";
import { all, apply, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { handleError } from "services/errorService";
import { oidc } from "services/oidcService";
import Cookies from "universal-cookie";
import { AUTH_REQUESTED, AUTH_REQUEST_FAILED, AUTH_SIGN_OUT, receiveAuth } from "./authActions";

export function* authenticate(cookies) {
  const oidcManager = yield call(oidc.getOidcManager);
  const token = yield call(oidc.getAccessToken);

  if (token) {
    yield put(receiveAuth());
    return;
  }

  let userInfo = null;
  try {
    userInfo = yield apply(oidcManager, oidcManager.signin);
  } catch (e) {
    handleError({ ...e, ...{ message: "Auth Error: " + e.message } });
    // if is in auth callback
    if (window.location.search.includes("state=")) {
      window.history.pushState(null, null, "/");
      window.location.reload();
    }
  }

  // The first we visit the site oidcManager.signin returns an empty object {}.
  // The second time (after callback) oidcManager.signin returns userInfo with tokens.
  if (userInfo && userInfo.tokens) {
    // Stores the auth cookies to detect if the user is logged in on SFP and Wordpress
    const domain = getPageDomain();

    yield call([cookies, cookies.set], "auth_access_token", userInfo.tokens.id_token, { path: "/", domain: domain });
    yield call([cookies, cookies.set], "auth_refresh_token", userInfo.tokens.refresh_token, {
      path: "/",
      domain: domain
    });

    const globalObject = yield call(getGlobalObject);
    globalObject.trackingHelper.trackAccountSubject(userInfo.sub);
    yield put(receiveAuth());
  }
}

export function* signOut(cookies, redirectUrl) {
  const oidcManager = yield call(oidc.getOidcManager);
  const domain = getPageDomain();

  yield call([cookies, cookies.remove], "auth_access_token", { path: "/", domain: domain });
  yield call([cookies, cookies.remove], "auth_refresh_token", { path: "/", domain: domain });
  yield apply(oidcManager, oidcManager.signout, [redirectUrl]);
}

export function* watchAuth() {
  yield all([
    takeLatest(
      AUTH_REQUESTED,
      doCall(() => authenticate(new Cookies()), AUTH_REQUEST_FAILED)
    ),
    takeEvery(
      AUTH_SIGN_OUT,
      doCall(action => signOut(new Cookies(), action.redirectUrl), AUTH_REQUEST_FAILED)
    )
  ]);
}

/**
 * Gets the high-level domain of the page
 * @return {String}
 */
function getPageDomain() {
  let domain = window.location.hostname;

  ["myaccount.", "t-dtap", "a-dtap", "www"].forEach(prefix => {
    domain = domain.replace(prefix, "");
  });

  return domain;
}
